// src/components/FeaturesSection.tsx
import SectionHeading from "./SectionHeading";
import { FEATURES } from "../data/content.js";

export default function FeaturesSection() {
  return (
    <section style={{ padding: "64px 48px", position: "relative", zIndex: 1 }}>
      <SectionHeading eyebrow="Features" title="Built for" accent="Builders" desc="Everything you need to build, play, and earn on MeeChain." center />
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(260px,1fr))", gap: 16 }}>
        {FEATURES.map(f => (
          <div key={f.title} style={{
            background: "var(--bg2)", border: "1px solid rgba(124,58,237,.2)",
            borderRadius: 12, padding: "20px 24px",
            transition: "border-color .2s, transform .2s",
          }}>
            <div style={{
              width: 48, height: 48, borderRadius: 12, marginBottom: 14,
              display: "flex", alignItems: "center", justifyContent: "center",
              fontSize: 22, background: `${f.color}18`, border: `1px solid ${f.color}44`,
            }}>{f.icon}</div>
            <div style={{ fontSize: 15, fontWeight: 700, color: "#fff", marginBottom: 8 }}>{f.title}</div>
            <div style={{ fontSize: 13, color: "var(--muted)", lineHeight: 1.6 }}>{f.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
